module.exports = __webpack_public_path__ + "static/media/musicboi.173f161f.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/musicboi.png
// module id = 85
// module chunks = 0